import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { ApiClientCredential } from '@era/settings-sdk';

export type ApiClientSettingState = EntityState<ApiClientCredential>;

export function selectIdFromSetting(conf: ApiClientCredential): string {
  return conf.id;
}

export const adapter: EntityAdapter<ApiClientCredential> = createEntityAdapter<ApiClientCredential>({
  selectId: selectIdFromSetting,
});

export const initialState: ApiClientSettingState = adapter.getInitialState();
